<template>
	<form class="form-horizontal" @submit.prevent="updateBasicUserDetails">
		<div class="row">
			<label class="col-sm-2 col-md-2 col-lg-2 col-form-label">First Name
				<strong class="text-danger">*</strong>
			</label>
			<div class="col-sm-4 col-md-4 col-lg-4">
				<div class="form-group">
					<input type="text" class="form-control" required v-model.trim="customer.firstName">
				</div>
			</div>
			<label class="col-sm-2 col-md-2 col-lg-2 col-form-label">Last Name
				<strong class="text-danger">*</strong>
			</label>
			<div class="col-sm-4 col-md-4 col-lg-4">
				<div class="form-group">
					<input type="text" class="form-control" required v-model.trim="customer.lastName">
				</div>
			</div>
		</div>
		<div class="row">
			<label class="col-sm-2 col-md-2 col-lg-2 col-form-label">Company Name</label>
			<div class="col-sm-4 col-md-4 col-lg-4">
				<div class="form-group">
					<input type="text" class="form-control" v-model.trim="customer.companyName">
				</div>
			</div>
			<label class="col-sm-2 col-md-2 col-lg-2 col-form-label">Address Line 1
				<strong class="text-danger">*</strong>
			</label>
			<div class="col-sm-4 col-md-4 col-lg-4">
				<div class="form-group">
					<input type="text" class="form-control" required v-model.trim="customer.addrLine1">
				</div>
			</div>
		</div>
		<div class="row">
			<label class="col-sm-2 col-md-2 col-lg-2 col-form-label">Address Line 2</label>
			<div class="col-sm-4 col-md-4 col-lg-4">
				<div class="form-group">
					<input type="text" class="form-control" v-model.trim="customer.addrLine2">
				</div>
			</div>
			<label class="col-sm-2 col-md-2 col-lg-2 col-form-label">City
				<strong class="text-danger">*</strong>
			</label>
			<div class="col-sm-4 col-md-4 col-lg-4">
				<div class="form-group">
					<input type="text" class="form-control" required v-model.trim="customer.city">
				</div>
			</div>
		</div>
		<div class="row">
			<label class="col-sm-2 col-md-2 col-lg-2 col-form-label">State/Province
				<strong class="text-danger">*</strong>
			</label>
			<div class="col-sm-4 col-md-4 col-lg-4">
				<div class="form-group">
					<input type="text" class="form-control" required v-model.trim="customer.state">
				</div>
			</div>
			<label class="col-sm-2 col-md-2 col-lg-2 col-form-label">Postal Code
				<strong class="text-danger">*</strong>
			</label>
			<div class="col-sm-4 col-md-4 col-lg-4">
				<div class="form-group">
					<input type="text" class="form-control" required v-model.trim="customer.postalCode">
				</div>
			</div>
		</div>
		<div class="row">
			<label class="col-sm-2 col-md-2 col-lg-2 col-form-label">Country Name
				<strong class="text-danger">*</strong>
			</label>
			<div class="col-sm-4 col-md-4 col-lg-4">
				<div class="form-group">
					<i class="fa fa-spinner animated rotateIn infinite" v-if="countries.length === 0"></i>
					<select class="selectpicker" required v-model.trim="customer.countryName" @change="getCountryCode(customer.countryName)" style="min-height: 3em;" data-live-search="true" v-else>
						<option value="" disabled>Choose your country name</option>
						<option v-for="country in countries" :key="country.alpha2Code">{{ country.name }}</option>
					</select>
				</div>
			</div>
			<label class="col-sm-2 col-md-2 col-lg-2 col-form-label">Country Code</label>
			<div class="col-sm-4 col-md-4 col-lg-4">
				<div class="form-group">
					<input type="text" class="form-control" disabled v-model.trim="customer.countryCode">
				</div>
			</div>
		</div>
<!--		<div class="row">-->
<!--			<label class="col-sm-2 col-md-2 col-lg-2 col-form-label">2FA Enable-->
<!--&lt;!&ndash;				<strong class="text-danger">*</strong>&ndash;&gt;-->
<!--			</label>-->
<!--			<div class="col-sm-4 col-md-4 col-lg-4">-->
<!--				<div class="bootstrap-switch bootstrap-switch-wrapper bootstrap-switch-animate" :class="{ 'bootstrap-switch-on bootstrap-switch-focused' : customer.twoFA, 'bootstrap-switch-off bootstrap-switch-focused' : !customer.twoFA }">-->
<!--					<div class="bootstrap-switch-container" @click="customer.twoFA = !customer.twoFA">-->
<!--						<span class="bootstrap-switch-handle-on bootstrap-switch-primary"><i class="fa fa-check" slot="on"></i></span>-->
<!--						<span class="bootstrap-switch-label"></span>-->
<!--						<span class="bootstrap-switch-handle-off bootstrap-switch-default"><i class="fa fa-times" slot="off"></i></span>-->
<!--					</div>-->
<!--				</div>-->
<!--			</div>-->
<!--		</div>-->
		<div class="row">
			<label class="col-sm-2 col-form-label"></label>
			<div class="col-sm-10">
				<div class="form-group">
					<button type="submit" class="btn btn-danger">Update Details</button>
				</div>
			</div>
		</div>
	</form>
</template>

<script>
import { db } from "@/firebase/init";

export default {
	name: "BasicDetailsUpdate",
  data() {
    return {
			customer: this.$store.getters["customer/details"],
			countries: []
    };
	},
  methods: {
		async fetchCountries() {
			try {
				const serverResp = await fetch('https://restcountries.eu/rest/v2/all')
				if(serverResp.ok) {
					const countryList = await serverResp.json()
					return countryList
				} else {
					throw new Error(`The network is returning ERROR: ${serverResp.status}`);
				}
			}
			catch(err) {
				throw new Error(err.message);
			}
		},
		getCountryCode(countryName) {
			this.countries.forEach(country => {
				if(country.name === countryName) {
					this.customer.countryCode = country.alpha2Code
				}
			})
		},
    updateBasicUserDetails() {
      // Check all the required fields are filled properly before submitting else show error
      if (
        this.customer.firstName &&
        this.customer.lastName &&
        this.customer.addrLine1 &&
        this.customer.city &&
        this.customer.state &&
        this.customer.postalCode &&
        this.customer.countryName &&
        this.customer.countryCode
      ) {
        // Set asyncDone to false
        this.$store.dispatch("async/stateUpdate", { state: false });

        // Update the changed records to the firestore database
        db
          .collection("users")
          .doc(this.customer.docID)
          .update({
            firstName: this.customer.firstName,
            lastName: this.customer.lastName,
            companyName: this.customer.companyName,
            addrLine1: this.customer.addrLine1,
            addrLine2: this.customer.addrLine2,
            city: this.customer.city,
            state: this.customer.state,
            postalCode: this.customer.postalCode,
            countryName: this.customer.countryName,
            countryCode: this.customer.countryCode,
			// twoFA:this.customer.twoFA,
			updatedAt: Date.now()
          })
          .then(() => {
            // Update the changed customer details to the Vuex state
            this.$store.commit("customer/userSelfDetailsMutate", {
              firstName: this.customer.firstName,
              lastName: this.customer.lastName,
              companyName: this.customer.companyName,
              addrLine1: this.customer.addrLine1,
              addrLine2: this.customer.addrLine2,
              city: this.customer.city,
              state: this.customer.state,
              postalCode: this.customer.postalCode,
              countryName: this.customer.countryName,
              countryCode: this.customer.countryCode,
				// twoFA:this.customer.twoFA,
			});

            // Set asyncDone to true
            this.$store.dispatch("async/stateUpdate", { state: true });

            // Show the alert for 5 sec
            this.$store.dispatch("alert/update", {
              type: "success",
              message: 'Your basic details has been updated successfully',
              show: true
            });

            setTimeout(() => {
              this.$store.dispatch("alert/showUpdate", { show: false });
            }, 5000);
          })
          .catch(err => {
            // Set asyncDone to true
            this.$store.dispatch("async/stateUpdate", { state: true });

            // Show the alert for 5 sec
            this.$store.dispatch("alert/update", {
              type: "danger",
              message: err,
              show: true
            });
              this.addLog({
                  message: "Error: Error update basic user details. Message:" + err.message,
                  level:  "danger"
              });

            setTimeout(() => {
              this.$store.dispatch("alert/showUpdate", { show: false });
            }, 5000);
          });
      } else {
        // Show the alert for 5 sec
        this.$store.dispatch("alert/update", {
          type: "danger",
          message:
            "Please make sure that all the required fields are filled properly",
          show: true
        });

        setTimeout(() => {
          this.$store.dispatch("alert/showUpdate", { show: false });
        }, 5000);
      }
    }
	},
	created() {
		this.fetchCountries()
		.then(countryList => {
			this.countries = [
				...countryList
			]
		})
	},
	updated() {
		/* eslint-disable */
		$( document ).ready(function() {
			$('.selectpicker').selectpicker();
		});
		/* eslint-enable */
	}
};
</script>
